import React, { Component } from 'react'
import GetApi from '../../api_request/Get';
import notifyError from '../../inc/SnackbarError';
import { CountryDropdown, RegionDropdown } from 'react-country-region-selector';
import { connect } from 'react-redux'
import randomString from 'random-string';
import { RedirectLink, ServerLink } from '../../keys/Links';
import postApi, { postApiMultipart } from '../../api_request/Post';
import Modal, { ModalCenter } from '../modals/Modal';
import FeatherIcon from 'feather-icons-react';
import { Link } from 'react-router-dom';

class AddMoney extends Component {


    constructor(props) {
        super(props);

        this.state = {
            cards: [],
            isLoading: false,
            isLoading2: false,
            amount: 0,
            selectCard: 'new',
            selectPurse: props.data && props.data.savings_uid ? props.data.savings_uid : 'default',
            modalSuccess: false,
            savings: [],
            studyBalance: '',
            purseTarget: '',
            totalSavings: '',
            paymentMethod: 'bank_transfer',
            uploadedFile: null,
            virtualAccountDetails: null,
            virtualAccountLoading: false


        }
    }

    componentDidMount() {
        this.getPurse();
        this.getVirtualAccountDetails();
    }

    /**
     * Fetch virtual account details from API
     */
    getVirtualAccountDetails = () => {
        this.setState({ virtualAccountLoading: true });
        
        GetApi(ServerLink + '/get-virtual-account').then(
            res => {
                console.log('Virtual Account Response:', res);
                
                if (res.status === true) {
                    this.setState({
                        virtualAccountDetails: res.data,
                        virtualAccountLoading: false
                    });
                } else {
                    notifyError(res.message || 'Failed to load virtual account details', 'error', 'top-center');
                    this.setState({ virtualAccountLoading: false });
                }
            }
        ).catch(e => {
            console.log('Virtual Account Error:', e);
            notifyError('Error loading virtual account details', 'error', 'top-center');
            this.setState({ virtualAccountLoading: false });
        });
    }


    getPurse = (e) => {

        //e.preventDefault();

        this.setState({
            isLoading: true
        })
        //get the Card
        GetApi(ServerLink + '/user/savings?q=all').then(
            res => {

                if (res.status == true) {

                    console.log(res)

                    this.setState({
                        savings: res.data,
                        studyBalance: res.purse_balance.smart_balance,
                        purseTarget: res.purse_balance.target,
                        totalSavings: res.totalSavings,
                        isLoading: false
                    })
                }
                else {

                    notifyError(res.message, 'error', 'top-center')


                    this.setState({
                        isLoading: false
                    })
                }
            }
        ).catch(e => {
            console.log(e)

            //notifyError('Oops.. Something went wrong, check your internet connection', 'error','top-center')
            notifyError(e, 'error', 'top-center')
            this.setState({
                isLoading: false
            })
        })
    }



    modalHandleSuccess = (e) => {
        e.preventDefault();

        console.log("hello");

        this.setState(
            {
                modalSuccess: !this.state.modalSuccess,

            }
        )
    }

    rediectx = (e) => {
        window.location.reload();
    }



    //transaction method
    confirmTransaction = (tran_id, userId, txRef) => {

        //e.preventDefault();
        this.setState({
            isLoading: false,
            modalSuccess: !this.state.modalSuccess,
        })


        //verify token transaction

        const data = {
            'id': tran_id,
            'user_uid': userId,
            'tx_ref': txRef
        }


        postApi(ServerLink + '/payment/verify_token_payment', data).then(
            res => {

                if (res.status == true) {

                    this.setState({
                        isLoading2: false,
                    })
                    console.log(res)

                } else {

                    console.log(res)
                    notifyError('Oops, Something went wrong', 'error', 'top-center')

                    this.setState({
                        isLoading: true
                    })
                }
            }).catch(e => {
                console.log(e)
            })

        //console.log(tran_id)
        //console.log(userId)
        //console.log(txRef)
    }

    handleInput = (i) => {
        i.preventDefault();
        const name = i.target.name;
        const value = i.target.value;
        this.setState({ [name]: value });
        //console.log(value)
    }

    handleFileUpload = (e) => {
        const file = e.target.files[0];
        if (file) {
            this.setState({ uploadedFile: file });
        }
    }

    handlePaymentMethodChange = (e) => {
        e.preventDefault();
        const method = e.target.value;
        this.setState({ paymentMethod: method });
    }

    handleSubmit = (e) => {

        e.preventDefault();

        // Validate required fields
        if (!this.state.amount || this.state.amount <= 0) {
            notifyError('Please enter a valid amount', 'error', 'top-center');
            return;
        }

        // Handle bank transfer
        if (this.state.paymentMethod === 'bank_transfer') {
            if (!this.state.uploadedFile) {
                notifyError('Please upload payment receipt for bank transfer', 'error', 'top-center');
                return;
            }

            this.setState({ isLoading: true });

            const formData = new FormData();
            formData.append('amount', this.state.amount);
            formData.append('purse_id', this.state.selectPurse);
            formData.append('payment_method', 'bank_transfer');
            formData.append('receipt', this.state.uploadedFile);
            formData.append('user_uid', this.props.userInfo.user_uid);
            formData.append('email', this.props.userInfo.email);

            // Log formData entries
            console.log('FormData entries:');
            for (let [key, value] of formData.entries()) {
                console.log(`${key}:`, value);
            }

            // You'll need to implement a file upload API endpoint
            postApiMultipart(ServerLink + '/payment/bank_transfer', formData).then(
                res => {
                    if (res.status == true || res.status == 'success') {

                        notifyError('Bank transfer submitted successfully. Please allow 5-10 minutes for confirmation.', 'success', 'top-center');
                        this.setState({
                            isLoading: false,
                            modalSuccess: true,
                            uploadedFile: null,
                            amount: 0
                        });

                         setTimeout(() => {
                            window.location.reload();
                        }, 3000);



                    } else {
                        notifyError(res.message || 'Failed to submit bank transfer', 'error', 'top-center');
                        this.setState({ isLoading: false });
                    }
                }
            ).catch(e => {
                console.log(e);
                notifyError('Error submitting bank transfer', 'error', 'top-center');
                this.setState({ isLoading: false });
            });

            return;
        }

        // Handle virtual account
        if (this.state.paymentMethod === 'virtual_account') {
            this.setState({ isLoading: true });

            const data = {
                'amount': this.state.amount,
                'purse_id': this.props.data.savings_uid ?? this.state.selectPurse, 
                'payment_method': 'virtual_account',
                'user_uid': this.props.userInfo.user_uid
            };

            notifyError('Virtual account transfer initiated', 'success', 'top-center');

            this.setState({
                isLoading: false,
                modalSuccess: true,
                amount: 0
            });

            /*

                postApi(ServerLink + '/payment/virtual_account', data).then(
                    res => {
                        if (res.status == true || res.status == 'success') {
                            notifyError('Virtual account transfer initiated', 'success', 'top-center');
                            this.setState({
                                isLoading: false,
                                modalSuccess: true,
                                amount: 0
                            });
                        } else {
                            notifyError(res.message || 'Failed to initiate virtual account transfer', 'error', 'top-center');
                            this.setState({ isLoading: false });
                        }
                    }
                ).catch(e => {
                    console.log(e);
                    notifyError('Error initiating virtual account transfer', 'error', 'top-center');
                    this.setState({ isLoading: false });
                });

            */

            return;
        }

        // Original card payment logic
        this.setState({
            isLoading: true
        })

        var trasactionRandId = 'StudyPurse-' + randomString({ length: 10 });

        //for reuseable cards i.e charge authorization

        if (this.state.selectCard !== 'new') {

            //console.log(this.state.selectCard)

            const dataRave = {
                'token': this.state.selectCard,
                'amount': this.state.amount,
                'tx_ref': trasactionRandId,
                'currency': this.props.userInfo.currency,
                'country': this.props.userInfo.country,
                'firstname': this.props.userInfo.firstname,
                'lastname': this.props.userInfo.lastname,
                'email': this.props.userInfo.email,
                'narration': 'Charges for smart purse saving',
                'meta': {
                    'firstname': this.props.userInfo.firstname,
                    'lastname': this.props.userInfo.lastname,
                    'email': this.props.userInfo.email,
                    'phonenumber': this.props.userInfo.phone,
                    'autosave': 'false',
                    'purseID': this.state.selectPurse,
                    'user_uid': this.props.userInfo.user_uid,
                    'webredirect_url': RedirectLink + '/#/dashboard',

                }
            }

            postApi(ServerLink + '/payment/charge_authorization', dataRave).then(
                res => {

                    if (res.status == 'success') {

                        this.setState({
                            isLoading: false,
                            //modalSuccess: !this.state.modalSuccess,
                        })

                        //query payment
                        const resInfo = {
                            'tx_ref': trasactionRandId,
                            'ref': trasactionRandId,
                            'transaction_id': res.data['id'],
                        }

                        //confirm transaction
                        var tran_id = res.data['id'];
                        var userId = this.props.userInfo.user_uid;
                        var txRef = trasactionRandId;

                        this.confirmTransaction(tran_id, userId, txRef);

                        //redirect to url
                        ///window.location.replace('payment_success');
                    }

                    else {

                        console.log(res)
                        notifyError('Oops, Something went wrong', 'error', 'top-center')

                        this.setState({
                            isLoading: true
                        })
                    }

                    console.log(res)
                }
            ).catch(e => {
                console.log(e)

                this.setState({
                    isLoading: false
                })
            })
        }
        //for new card payment
        else {

            const data = {
                'amount': this.state.amount * 100,
                'email': this.props.userInfo.email,
                'callback_url': ServerLink + '/payment/transaction',
                'reference': trasactionRandId,
                'metadata': {
                    'firstname': this.props.userInfo.firstname,
                    'lastname': this.props.userInfo.lastname,
                    'user_uid': this.props.userInfo.user_uid,
                    'redirect_url': RedirectLink + '/#/dashboard',
                    'autosave': false
                }
            }

            const dataRave = {
                'amount': this.state.amount,
                'redirect_url': ServerLink + '/payment/transaction',
                'tx_ref': trasactionRandId,
                'currency': this.props.userInfo.currency,
                'payment_options': 'card,bank,ussd',
                'meta': {
                    'firstname': this.props.userInfo.firstname,
                    'lastname': this.props.userInfo.lastname,
                    'email': this.props.userInfo.email,
                    'phonenumber': this.props.userInfo.phone,
                    'autosave': 'false',
                    'user_uid': this.props.userInfo.user_uid,
                    'webredirect_url': RedirectLink + '/#/dashboard',
                },

                'customer': {
                    'name': this.props.userInfo.firstname + ' ' + this.props.userInfo.lastname,
                    'email': this.props.userInfo.email,
                    'phonenumber': this.props.userInfo.phone,
                },
                "customizations": {
                    "title": "SmartPurse",
                    "description": "Middleout isn't free. Pay the price",
                    "logo": "http://studypurse.herokuapp.com/static/media/slogo2.3fdc8404.jpg"
                }

            }

            //postApi(ServerLink+'/payment/paystack', data).then(
            postApi(ServerLink + '/payment/saverave', dataRave).then(

                res => {

                    // if(res.status == true){
                    //     this.setState({
                    //         isLoading: false
                    //     })

                    //     window.location.replace(res.data.authorization_url);
                    // }


                    if (res.status == 'success') {
                        this.setState({
                            isLoading: false
                        })

                        window.location.replace(res.data.link);
                    }

                    else {
                        notifyError('Oops, Something went wrong', 'error', 'top-center')

                        this.setState({
                            isLoading: false
                        })
                    }

                    console.log(res)
                }
            ).catch(e => {
                console.log(e)

                this.setState({
                    isLoading: false
                })
            })

            console.log(this.state.selectCard)
        }
    }


    ModalContentSuccess = () => {

        if (this.state.modalSuccess) {

            return (
                <Modal show={this.state.modalSuccess} modalClosed={this.modalHandleSuccess}>
                    <div>



                    </div>
                </Modal>
            )
        }
    }



    render() {

        const paymentMethods = [
            // {
            //     id: 'card',
            //     icon: 'credit-card',
            //     title: 'Debit Card',
            //     description: 'Use your card instantly',
            //     color: 'from-blue-400 to-blue-600'
            // },
            {
                id: 'bank_transfer',
                icon: 'home',
                title: 'Bank Transfer',
                description: 'Transfer from your bank account',
                color: 'from-purple-400 to-purple-600'
            },
            {
                id: 'virtual_account',
                icon: 'smartphone',
                title: 'Virtual Account',
                description: 'Instant transfer via virtual account',
                color: 'from-green-400 to-green-600'
            }
        ];

        return (
            <div>

                <Modal show={this.state.modalSuccess} modalClosed={this.modalHandleSuccess}>
                    <div>
                        {
                            this.state.isLoading2 ?

                                <div className="pt-40">

                                    <h4 className="text-center">Loading...</h4>
                                </div>

                                :

                                <div className="">
                                    <a onClick={this.rediectx} className="float-right">
                                        <FeatherIcon icon="x-circle" />
                                    </a>

                                    <div className="pt-30">
                                        <img src={require('./../../dist/images/undraw/card-success.jpg')} className="rounded-full" />

                                        <div className="text-center">
                                            <h3 className="f-Raleway text-blue-700 mb-10">Payment Successful !!!</h3>

                                            <Link to='/history' className="py-3 px-4 mt-5 text-white bg-blue-400"> See Transaction History</Link>
                                        </div>
                                    </div>


                                </div>

                        }


                    </div>
                </Modal>

                {/* Loading Overlay */}
                {(this.state.isLoading || this.state.virtualAccountLoading) && (
                    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
                        <div className="bg-white rounded-xl p-8 shadow-2xl flex flex-col items-center">
                            <div className="animate-spin mb-4">
                                <FeatherIcon icon="loader" size="40" className="text-blue-600" />
                            </div>
                            <h3 className="text-lg font-bold text-gray-800 text-center">
                                {this.state.virtualAccountLoading ? 'Loading Virtual Account...' : 'Processing...'}
                            </h3>
                            <p className="text-sm text-gray-500 mt-2 text-center">Please wait while we complete your request</p>
                        </div>
                    </div>
                )}

                <form onSubmit={this.handleSubmit} method="POST">
                    <div className="mb-8 text-center">
                        <h3 className="workSanBold text-2xl text-gray-800">Add Money</h3>
                        <p className="workSan text-gray-500 mt-1">Fund your Smart Purse with your preferred method</p>
                    </div>

                    {/* Amount Input */}
                    <div className="mb-6">
                        <label className="workSanMedium text-gray-700 block mb-2">Amount</label>
                        <div className="relative">
                            <span className="absolute left-3 top-3 text-gray-500 text-xl">₦</span>
                            <input
                                name="amount"
                                onChange={this.handleInput}
                                className="pl-8 pr-3 py-3 border border-gray-300 w-full rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                                type="number"
                                placeholder="Enter amount"
                                value={this.state.amount}
                            />
                        </div>
                    </div>

                    {/* Select Purse */}
                    <div className="mb-6">
                        <label className="workSanMedium text-gray-700 block mb-2">Select Savings Purse</label>
                        <select
                            name="selectPurse"
                            onChange={this.handleInput}
                            disabled={this.props.data && this.props.data.savings_uid}
                            className="px-3 py-3 border border-gray-300 w-full rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent disabled:bg-gray-100 disabled:cursor-not-allowed"
                        >
                            <option value="smart_purse">Smart Purse</option>
                            {
                                this.state.savings.map((purse, index) => (
                                    <option key={index} value={purse.savings_uid} selected={this.props.data && this.props.data.savings_uid && this.props.data.savings_uid === purse.savings_uid}  > {purse.title} </option>
                                ))}
                        </select>
                    </div>

                    {/* Payment Method Selection */}
                    <div className="mb-8">
                        <label className="workSanMedium text-gray-700 block mb-4">Choose Payment Method</label>
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                            {paymentMethods.map((method) => (
                                <div
                                    key={method.id}
                                    onClick={() => this.setState({ paymentMethod: method.id })}
                                    className={`p-4 rounded-xl cursor-pointer transition-all duration-300 transform hover:scale-105 ${this.state.paymentMethod === method.id
                                            ? `bg-gradient-to-br ${method.color} text-white shadow-lg ring-2 ring-offset-2 ring-blue-500`
                                            : 'bg-white border-2 border-gray-200 hover:border-blue-300 text-gray-700'
                                        }`}
                                >
                                    <div className="flex flex-col items-center text-center">
                                        <FeatherIcon
                                            icon={method.icon}
                                            size="32"
                                            className={`mb-2 ${this.state.paymentMethod === method.id ? 'text-white' : 'text-blue-500'}`}
                                        />
                                        <h4 className="font-bold text-sm mb-1">{method.title}</h4>
                                        <p className={`text-xs ${this.state.paymentMethod === method.id ? 'text-blue-100' : 'text-gray-500'}`}>
                                            {method.description}
                                        </p>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>

                    {/* Card Payment Section */}
                    {this.state.paymentMethod === 'card' && (
                        <div className="mb-6 p-4 bg-gradient-to-br from-blue-50 to-blue-100 rounded-xl border border-blue-200 animate-fadeIn">
                            <label className="workSanMedium text-gray-700 block mb-3 flex items-center">
                                <FeatherIcon icon="credit-card" size="18" className="text-blue-600 mr-2" />
                                Select Card
                            </label>
                            <select
                                name="selectCard"
                                onChange={this.handleInput}
                                className="px-3 py-3 border border-blue-300 w-full rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 bg-white"
                            >
                                <option value="new">+ Add New Card</option>
                                {
                                    this.state.cards.map((card, index) => (
                                        <option key={index} value={card.authorization_id}>
                                            •••• {card.last4}
                                        </option>
                                    ))}
                            </select>
                        </div>
                    )}

                    {/* Bank Transfer Section */}
                    {this.state.paymentMethod === 'bank_transfer' && (
                        <div className="mb-6 animate-fadeIn">
                            <div className="p-4 bg-gradient-to-br from-purple-50 to-purple-100 border border-purple-200 rounded-xl mb-4">
                                <div className="flex items-start mb-3">
                                    <FeatherIcon icon="building" size="20" className="text-purple-600 mr-3 mt-1" />
                                    <div>
                                        <h5 className="workSanBold text-purple-800 mb-2">Bank Details</h5>
                                        <div className="grid grid-cols-1 gap-2">
                                            <div className="bg-white p-0 rounded-lg">
                                                <label className="text-xs text-gray-600 font-semibold uppercase">Account Number</label>
                                                <p className="font-bold text-gray-800 text-lg mb-0">0147634451</p>
                                            </div>
                                            <div className="bg-white p-0 rounded-lg">
                                                <label className="text-xs text-gray-600 font-semibold uppercase">Bank Name</label>
                                                <p className="font-bold text-gray-800 mb-0">Sterling Bank</p>
                                            </div>
                                            <div className="bg-white p-0rounded-lg">
                                                <label className="text-xs text-gray-600 font-semibold uppercase">Account Name</label>
                                                <p className="font-bold text-gray-800 mb-0">Hypersence Limited</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div>
                                <label className="workSanMedium text-gray-700 block mb-2 flex items-center">
                                    <FeatherIcon icon="upload" size="18" className="text-purple-600 mr-2" />
                                    Upload Payment Receipt
                                </label>
                                <div className="relative border-2 border-dashed border-purple-300 rounded-lg p-6 text-center hover:border-purple-500 transition-colors bg-purple-50">
                                    <input
                                        type="file"
                                        onChange={this.handleFileUpload}
                                        accept="image/*,.pdf"
                                        className="absolute inset-0 w-full h-full opacity-0 cursor-pointer"
                                        required
                                    />
                                    <div className="pointer-events-none">
                                        <FeatherIcon icon="file-text" size="32" className="text-purple-400 mx-auto mb-2" />
                                        <p className="text-sm text-gray-600">Click to upload or drag and drop</p>
                                        <p className="text-xs text-gray-500">PNG, JPG, PDF (Max. 5MB)</p>
                                    </div>
                                </div>
                                {this.state.uploadedFile && (
                                    <div className="mt-3 p-3 bg-green-50 border border-green-200 rounded-lg flex items-center">
                                        <FeatherIcon icon="check-circle" className="text-green-600 mr-2" size="18" />
                                        <p className="text-sm text-green-700 font-medium">{this.state.uploadedFile.name}</p>
                                    </div>
                                )}
                            </div>
                        </div>
                    )}

                    {/* Virtual Account Section */}
                    {this.state.paymentMethod === 'virtual_account' && (
                        <div className="mb-6 animate-fadeIn">
                            <div className="p-4 bg-gradient-to-br from-green-50 to-green-100 border border-green-200 rounded-xl">
                                <div className="flex items-start mb-4">
                                    <FeatherIcon icon="smartphone" size="20" className="text-green-600 mr-3 mt-1" />
                                    <div className="w-full">
                                        <h5 className="workSanBold text-green-800 mb-1">Your Virtual Account</h5>
                                        <p className="text-sm text-green-700">Transfer funds instantly to this virtual account</p>
                                    </div>
                                </div>

                                <div className="space-y-2">
                                    {this.state.virtualAccountLoading ? (
                                        <div className="bg-white p-3 rounded-lg border border-green-100 text-center">
                                            <p className="text-sm text-gray-600">Loading virtual account details...</p>
                                        </div>
                                    ) : this.state.virtualAccountDetails ? (
                                        <>
                                            <div className="bg-white p-3 rounded-lg border border-green-100">
                                                <label className="text-xs text-gray-600 font-semibold uppercase">Virtual Account Number</label>
                                                <p className="font-bold text-gray-800 text-lg tracking-wider">{this.state.virtualAccountDetails.account_number}</p>
                                            </div>
                                            <div className="bg-white p-3 rounded-lg border border-green-100">
                                                <label className="text-xs text-gray-600 font-semibold uppercase">Bank</label>
                                                <p className="font-bold text-gray-800">{this.state.virtualAccountDetails.bank_name}</p>
                                            </div>
                                            <div className="bg-white p-3 rounded-lg border border-green-100">
                                                <label className="text-xs text-gray-600 font-semibold uppercase">Account Name</label>
                                                <p className="font-bold text-gray-800">{this.state.virtualAccountDetails.account_name}</p>
                                            </div>
                                        </>
                                    ) : (
                                        <div className="bg-white p-3 rounded-lg border border-red-100 text-center">
                                            <p className="text-sm text-red-600">Unable to load virtual account details</p>
                                        </div>
                                    )}
                                </div>

                                <div className="mt-3 p-3 bg-green-50 border border-green-200 rounded-lg">
                                    <p className="text-xs text-green-700 flex items-start">
                                        <FeatherIcon icon="info" size="16" className="mr-2 mt-0.5 flex-shrink-0" />
                                        Transfers are usually reflected within 5-10 minutes
                                    </p>
                                </div>
                            </div>
                        </div>
                    )}

                    {/* Submit Button */}
                    <div className="mb-6">
                        {
                            this.state.isLoading ?
                                <button
                                    type="button"
                                    className="w-full py-3 px-4 bg-gradient-to-r from-blue-400 to-blue-600 text-white font-bold rounded-lg flex items-center justify-center space-x-2 cursor-not-allowed opacity-80"
                                >
                                    <div className="animate-spin">
                                        <FeatherIcon icon="loader" size="18" />
                                    </div>
                                    <span>Processing...</span>
                                </button>
                                :
                                <button
                                    type="submit"
                                    className="w-full py-3 px-4 bg-gradient-to-r from-blue-600 to-blue-800 text-white font-bold rounded-lg hover:shadow-lg transition-all duration-300 transform hover:scale-105 flex items-center justify-center space-x-2"
                                >
                                    <FeatherIcon icon="check-circle" size="18" />
                                    <span>Complete Transaction</span>
                                </button>
                        }
                    </div>
                </form>
            </div>
        )
    }
}



const mapStateToProps = state => {

    return {
        loggedIn: state.auth.loggedIn,
        userInfo: state.auth.user

    }
}


export default connect(mapStateToProps, '')(AddMoney)